// Layer names used in the application
export const BranchLayer = 'nzgreens:branches';
export const OldBranchesLayer = 'nzgreens:gbranch20h';
export const ElectorateLayer = 'nzgreens:electorates';
export const RegionalCouncilLayer = 'nzgreens:regional_councils';
// Limit the layers that can be requested
// Just because I suspect the Meshblocks layers will be way too chunky
export const ALLOWED_LAYERS = [
    BranchLayer,
    OldBranchesLayer,
    ElectorateLayer,
    RegionalCouncilLayer
];
